import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Stack, useTheme } from "@mui/material";
import BackButton from "../../../components/BackButton";
import LabelTxtFieldInfo from "../../../components/LabelTxtFieldInfo";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import route from "../../../utils/Routes";
import { customAlert, notify } from "../../../components/notify";
import BgBoxOld from "../../../components/BgBoxOld";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { datePickerformat, isNotEmpty } from "../../../utils/format";
import { editDoInvServ, getSingleDoServ } from "../../../services/po-service";
import CtrlCustomDropDown from "../../../components/CtrlCustomDropDown";


const pymtStatusArr = [
    { value: "na", label: "NA" },
    { value: "unpaid", label: "UNPAID" },
    { value: "partially_paid", label: "PARTIALLY PAID" },
    { value: "paid", label: "PAID" }];

function EditDoInvPage() {
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const { doIdStrg } = location.state || {};
    const { setLoadingScreen } = useAuthContext();
    const [selection, setSelection] = useState({ pymtStatus: "" });
    const [formErrors, setFormErrors] = useState({});

    const { isLoading, isError, error, data: doData } = useQuery([QueryKey.doInfo, doIdStrg],
        () => getSingleDoServ(doIdStrg),
        {
            enabled: isNotEmpty(doIdStrg),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });


    useEffect(() => {
        if (!doIdStrg)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [doIdStrg])


    useEffect(() => {
        if (!doData)
            return
        setSelection({ pymtStatus: doData?.pymtStatus })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [doData])

    useEffect(() => {
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);



    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                doIdStrg,
                invNo: inputObject.invNo,
                pymtStatus: selection.pymtStatus,
                invDate: isNotEmpty(inputObject.invDate) ? inputObject.invDate : null,
            }
            console.dir(payload);
            const { message } = await editDoInvServ(payload);
            notify("success", message);
            navigate(`${route.aDoInfo}/?doId=${doIdStrg}`, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };


    function validate(values) {
        const errors = {};
        // if (!values.catName)
        //     errors.catName = "Category Name is required!";

        return errors;
    };



    function handleCancel() {
        navigate(`${route.aDoInfo}/?doId=${doIdStrg}`, { replace: true })
    }

    function handleDDChange(e) {
        const { name, value } = e.target;
        setSelection((e) => { return { ...e, [name]: value } });
    }


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }


    return (
        <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
            <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
                <BackButton />
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Update Delivery Order Invoice </Typography>
                <Box />
            </Stack>
            <BgBoxOld height={"93%"} py={1}>
                {doData && <Stack direction={"row"} height={"100%"} gap={6} mt={1} sx={{ position: "relative" }}>
                    <Stack gap={1} width={"100%"}>
                        <LabelTxtFieldInfo name="doIdStrg" defaultValue={doIdStrg} readOnly={true} title="Delivery Order Id" bgColor={"rgba(162, 214, 249, 0.18)"} width={250} height={30} borderRadius={1} rows={1} />
                        <LabelTxtFieldInfo name="invNo" defaultValue={doData?.invNo} errMsg={formErrors.invNo} title="invNo" width={250} height={30} borderRadius={1} rows={1} />
                        <LabelTxtFieldInfo name="invDate" type='date' defaultValue={datePickerformat(doData?.invDate)} errMsg={formErrors.invDate} title="invDate " width={250} height={30} borderRadius={1} rows={1} />
                        <CtrlCustomDropDown name="pymtStatus" errMsg={formErrors.pymtStatus} title={"Payment Status"} width={250} height={30} borderRadius={1}
                            handleDDChange={handleDDChange} ddArr={pymtStatusArr} value={selection.pymtStatus} needNone={false} />
                        <Stack width={"30%"} alignItems={"end"} mt={4}>
                            <Stack direction={"row"} alignItems={"center"}>
                                <Button variant="outlined" onClick={handleCancel} sx={{
                                    fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                                    color: theme.palette.custom.btn, mr: 2,
                                }}>CANCEL</Button>
                                <Button variant="contained" type="submit"
                                    sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>SAVE</Button>
                            </Stack>
                        </Stack>
                    </Stack>

                </Stack>}
            </BgBoxOld>
        </form>
    );
};

export default EditDoInvPage;